module.exports = __webpack_public_path__ + "a768e7de/img/scraper-icon.df6ccde5.svg";